// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G9ouO6Pssh {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.G9ouO6Pssh h4 {
  line-height: 3em;
}
.G9ouO6Pssh .QaF9gMPzPb {
  float: left;
  width: 100%;
}
.G9ouO6Pssh .qEVUVv_NHn {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.G9ouO6Pssh .qEVUVv_NHn:hover {
  cursor: pointer;
}
.G9ouO6Pssh .qEVUVv_NHn:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.NDUzR2ynGu .EKmSz7bpVe:focus {
  outline: none;
}
.NDUzR2ynGu .EKmSz7bpVe.g4hOwEz6Cm.MJHZ2vBNnP {
  background: #375A88;
}
.NDUzR2ynGu .EKmSz7bpVe.g4hOwEz6Cm.MJHZ2vBNnP span {
  color: #fff;
}
.NDUzR2ynGu .MJHZ2vBNnP {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.NDUzR2ynGu .MJHZ2vBNnP:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.NDUzR2ynGu input {
  height: 38px;
  min-width: 220px;
}
.qEVUVv_NHn.pVnQlUzh5l {
  background: #410102;
}
.qEVUVv_NHn.jmBhsjPzvl {
  background: #911318;
}
.qEVUVv_NHn.lRg6zkuHWv {
  background: #D8293B;
}
.qEVUVv_NHn.orTnL6DCsW {
  background: #F2373C;
}
.qEVUVv_NHn.Xg7obBOd3A {
  background: #FC4448;
}
.qEVUVv_NHn.yXbqtuIFpy {
  background: #ED535E;
}
.qEVUVv_NHn.NNmjhz4G0Z {
  background: #E34926;
}
.qEVUVv_NHn._p8JXhy436 {
  background: #FC562B;
}
.qEVUVv_NHn.y7lz2fxIFf {
  background: #FC6722;
}
.qEVUVv_NHn.KSVUaFEp7G {
  background: #FD7F24;
}
.qEVUVv_NHn.I6xuhWw1CA {
  background: #FD8D26;
}
.qEVUVv_NHn.JB2t7vDrNs {
  background: #EC9C3E;
}
.qEVUVv_NHn.PXSK_ufvIz {
  background: #0e673a;
}
.qEVUVv_NHn.b9OgfxkdUL {
  background: #208740;
}
.qEVUVv_NHn.mBa7s33y9o {
  background: #239718;
}
.qEVUVv_NHn.ALkxLy3ERW {
  background: #55A84D;
}
.qEVUVv_NHn.VuMsgq6CjJ {
  background: #4BBE5A;
}
.qEVUVv_NHn.HSd59qR2m3 {
  background: #0CCA6A;
}
.qEVUVv_NHn._9KE6aJFTdn {
  background: #0A3C64;
}
.qEVUVv_NHn.yJDcxG8t68 {
  background: #0d487a;
}
.qEVUVv_NHn.X82Qb3Efeb {
  background: #10538d;
}
.qEVUVv_NHn.aul2vgQ9vG {
  background: #115A99;
}
.qEVUVv_NHn.fA2YqrjHRM {
  background: #3387E2;
}
.qEVUVv_NHn.hbWiaEXEGs {
  background: #1BA9CF;
}
.qEVUVv_NHn.yHuLAa6ZY6 {
  background: #d27c02;
}
.qEVUVv_NHn.sTeSgzF1XK {
  background: #fb9402;
}
.qEVUVv_NHn.EQIOn9yDOa {
  background: #FD9B30;
}
.qEVUVv_NHn.pVGQ0ljnVn {
  background: #FDBE2D;
}
.qEVUVv_NHn.XimixPxvH0 {
  background: #FED831;
}
.qEVUVv_NHn.DzhBkyC9Ug {
  background: #FFFD38;
}
.qEVUVv_NHn.ksIoC_gxEX {
  background: #2D215C;
}
.qEVUVv_NHn.xeNGLmNsNT {
  background: #483C83;
}
.qEVUVv_NHn.ZCgcU16dD2 {
  background: #58518d;
}
.qEVUVv_NHn.T0lEaZ_1Mw {
  background: #7068A9;
}
.qEVUVv_NHn.JzE6BAMu1N {
  background: #7f78b2;
}
.qEVUVv_NHn.Y2McnTt8vv {
  background: #8f88bc;
}
.qEVUVv_NHn.oIdp8SDBS8 {
  background: #000;
}
.qEVUVv_NHn.UMEKICTjqH {
  background: #282626;
}
.qEVUVv_NHn.aiBrYyzBx0 {
  background: #242222;
}
.qEVUVv_NHn.QSwTMny9nq {
  background: #353838;
}
.qEVUVv_NHn.TrupxMxbT6 {
  background: #666;
}
.qEVUVv_NHn.LImIPwwJco {
  background: #999;
}
.bL26ahAUku {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.bL26ahAUku .bNxZQ3yG7w {
  display: none;
}
.hBfUPxfmGi {
  min-width: 900px;
}
.hBfUPxfmGi .ixxlGHi6Ap {
  position: relative;
  max-height: 66px;
  background-color: #375A87;
}
.hBfUPxfmGi .ixxlGHi6Ap .p97ZLuUSuN {
  display: flex;
  align-items: baseline;
}
.hBfUPxfmGi .ixxlGHi6Ap .p97ZLuUSuN .wz7m6ZurYC.wz7m6ZurYC {
  font-size: 20px;
}
.hBfUPxfmGi .ixxlGHi6Ap .p97ZLuUSuN .ddYX1SI08Q {
  font-size: 28px;
}
.hBfUPxfmGi .sbBrTbVblc {
  padding: 20px;
  height: 420px;
}
.hBfUPxfmGi .sbBrTbVblc .b-react-portal-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hBfUPxfmGi .sbBrTbVblc .Hpa_3ob4vw {
  border: solid 1px #e5e5e5;
  background-color: #f5f5f5;
  height: 32px;
  margin-bottom: 20px;
  width: 280px;
}
.hBfUPxfmGi .sbBrTbVblc .Hpa_3ob4vw .czALKTePwm {
  border: none;
  font-size: 12px !important;
  padding: 0;
}
.hBfUPxfmGi .sbBrTbVblc .Hpa_3ob4vw .aZkdCscxKG {
  font-size: 16px;
  padding: 4px 12px;
}
.hBfUPxfmGi .sbBrTbVblc .kMsye61qns {
  height: 18px;
  width: 100px;
}
.hBfUPxfmGi .sbBrTbVblc .znjj02GaZC {
  background-color: #fff;
  color: #000000;
  border: 1px solid #DDDDDD;
  font-weight: 400;
  border-radius: 2px;
}
.hBfUPxfmGi .sbBrTbVblc .znjj02GaZC .YL4ahTN0z7 > i {
  font-size: 12px;
}
.hBfUPxfmGi .J3gmiXb7xM {
  height: 354px;
  margin: 20px;
  background-color: #f3f4f5;
  text-align: center;
  padding: 40px 120px;
}
.hBfUPxfmGi .J3gmiXb7xM > i {
  color: #999999;
  font-size: 100px;
}
.hBfUPxfmGi .J3gmiXb7xM .nfIcJQ5MFj {
  font-size: 22px;
}
.hBfUPxfmGi .J3gmiXb7xM .omgn7GmXoy {
  font-size: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `G9ouO6Pssh`,
	"color-row": `QaF9gMPzPb`,
	"color-tile": `qEVUVv_NHn`,
	"picker-component": `NDUzR2ynGu`,
	"picker-element": `EKmSz7bpVe`,
	"active": `g4hOwEz6Cm`,
	"btn": `MJHZ2vBNnP`,
	"red-1": `pVnQlUzh5l`,
	"red-2": `jmBhsjPzvl`,
	"red-3": `lRg6zkuHWv`,
	"red-4": `orTnL6DCsW`,
	"red-5": `Xg7obBOd3A`,
	"red-6": `yXbqtuIFpy`,
	"orange-1": `NNmjhz4G0Z`,
	"orange-2": `_p8JXhy436`,
	"orange-3": `y7lz2fxIFf`,
	"orange-4": `KSVUaFEp7G`,
	"orange-5": `I6xuhWw1CA`,
	"orange-6": `JB2t7vDrNs`,
	"green-1": `PXSK_ufvIz`,
	"green-2": `b9OgfxkdUL`,
	"green-3": `mBa7s33y9o`,
	"green-4": `ALkxLy3ERW`,
	"green-5": `VuMsgq6CjJ`,
	"green-6": `HSd59qR2m3`,
	"blue-1": `_9KE6aJFTdn`,
	"blue-2": `yJDcxG8t68`,
	"blue-3": `X82Qb3Efeb`,
	"blue-4": `aul2vgQ9vG`,
	"blue-5": `fA2YqrjHRM`,
	"blue-6": `hbWiaEXEGs`,
	"yellow-1": `yHuLAa6ZY6`,
	"yellow-2": `sTeSgzF1XK`,
	"yellow-3": `EQIOn9yDOa`,
	"yellow-4": `pVGQ0ljnVn`,
	"yellow-5": `XimixPxvH0`,
	"yellow-6": `DzhBkyC9Ug`,
	"purple-1": `ksIoC_gxEX`,
	"purple-2": `xeNGLmNsNT`,
	"purple-3": `ZCgcU16dD2`,
	"purple-4": `T0lEaZ_1Mw`,
	"purple-5": `JzE6BAMu1N`,
	"purple-6": `Y2McnTt8vv`,
	"black-1": `oIdp8SDBS8`,
	"black-2": `UMEKICTjqH`,
	"black-3": `aiBrYyzBx0`,
	"black-4": `QSwTMny9nq`,
	"black-5": `TrupxMxbT6`,
	"black-6": `LImIPwwJco`,
	"picker-theme": `bL26ahAUku`,
	"arrow-regular": `bNxZQ3yG7w`,
	"modal-root": `hBfUPxfmGi`,
	"modal-header__root": `ixxlGHi6Ap`,
	"modal-header__ctn": `p97ZLuUSuN`,
	"modal-header__title": `wz7m6ZurYC`,
	"modal-header__icon": `ddYX1SI08Q`,
	"linked-tasks__ctn": `sbBrTbVblc`,
	"filter-input__root": `Hpa_3ob4vw`,
	"filter-input__input": `czALKTePwm`,
	"filter-input__icon": `aZkdCscxKG`,
	"status-chip": `kMsye61qns`,
	"go-to-task-btn": `znjj02GaZC`,
	"go-to-task__icon": `YL4ahTN0z7`,
	"linked-tasks__no-task": `J3gmiXb7xM`,
	"no-linked-task__title": `nfIcJQ5MFj`,
	"no-linked-task__description": `omgn7GmXoy`
};
export default ___CSS_LOADER_EXPORT___;
